// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gallery-root-BDi {\n    grid-template-areas:\n        'actions'\n        'items';\n}\n\n.gallery-items-mt3 {\n    grid-area: items;\n    grid-template-columns: repeat(3, 1fr);\n}\n\n@media (max-width: 639px) {\n    .gallery-items-mt3 {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "gallery-root-BDi grid grid-cols-1 leading-none",
	"items": "gallery-items-mt3 gap-xs grid mb-3"
};
export default ___CSS_LOADER_EXPORT___;
